import { NotificationDelay, NotificationStyle } from './notifications.constants.js';
import { Notification } from './notification.js';
import Vue from 'vue';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class NotificationService {
  constructor() {
    this.lastMessageId = 0;
    Vue.set(this, "notifications", {});
  }
  show(body, options) {
    const id = ++this.lastMessageId + "";
    options = options || {};
    options.closeDelay = options.closeDelay || NotificationDelay.DEFAULT;
    options.dismissible = typeof options.dismissible === "boolean" ? options.dismissible : true;
    const notification = new Notification(body, options, id);
    Vue.set(this.notifications, id, notification);
    if (options.closeDelay !== NotificationDelay.PERMANENT) {
      setTimeout(() => {
        this.close(notification);
      }, options.closeDelay);
    }
    return notification;
  }
  error(body, options) {
    return this.show(body, __spreadProps(__spreadValues({}, options), {
      style: NotificationStyle.ERROR
    }));
  }
  success(body, options) {
    return this.show(body, __spreadProps(__spreadValues({}, options), {
      style: NotificationStyle.SUCCESS
    }));
  }
  close(notification) {
    if (notification.id in this.notifications) {
      const currNotification = this.notifications[notification.id];
      Vue.delete(this.notifications, notification.id);
      if (currNotification.onClose) {
        currNotification.onClose();
      }
    }
  }
  closeAllNotifications() {
    Object.values(this.notifications).forEach((notification) => this.close(notification));
  }
}
const notificationService = new NotificationService();

export { NotificationService, notificationService };
